import React from 'react';
import cn from 'classnames';

import Icon from '../Icon';
import useSettingsDropdown from './useSettingsDropdown';
import './settingsDropdown.scss';

interface Props {
    title: string;
    width?: number;
    height?: number;
    glyph: {
        id: string;
        content: string;
        viewBox: string;
    };
}

const SettingsDropdown: React.SFC<Props> = ({
    title,
    children,
    glyph,
    width,
    height,
}) => {
    const { isOpen, toggle, container } = useSettingsDropdown();

    return (
        <div
            ref={container}
            styleName={cn('container', { 'is-open': isOpen })}
            title={title}
        >
            <div styleName="stub" onClick={toggle}>
                <Icon
                    glyph={glyph}
                    styleName="icon"
                    width={width}
                    height={height}
                />
                <div styleName="caret" />
            </div>
            {isOpen && children}
        </div>
    );
};

export default SettingsDropdown;
